module.exports = __webpack_public_path__ + "images/bannerIT-385cf7b388b5c4f15c1235b807663b75.jpg";